import React from 'react';
import Portfolio from "./portfolio.component";
import './portfolio-section.styles.scss'

const PortfolioSection = () => {
    return (
        <section className="portfolio-section">
            <Portfolio/>
        </section>
    )
}

export default PortfolioSection